<template>
  <div style="position: static">
    <div class="ba-page-node-arrow" :style="{ 'z-index': active ? -1 : -2 }" @click="$emit('onResetActive')">
      <ba-page-node-arrow v-if="!all"
              :positionX="`${itemDistance.x * (index.x - 2) + itemDistance.first.x + arrowStartGap}px`"
              :positionY="`${itemDistance.first.y - 20}px`"
              :width="arrowWidth"
              :height="arrowHeight"
              :maxOverlap="indexMax.y"
              :start="arrowStart"
              :end="arrowEnd"
              :weight="transitionWeight"
              :index="from.index"
              :time="arrowTime"
              :active="active"
              :startColor="active && index.x > 2 ? '#0e90a5' : '#ecede6'"
              :endColor="active ? '#0e90a5' : '#97bd12'"
              :disabledStartColor="reportShowing ? '#dbdbd8' : '#ecede6'"
              :disabledEndColor="reportShowing ? (active ? '#b0c9cd' : '#d2dea8') : '#d2dea8'"
              :disabled="this.reportShowing || nodeDisabled"
              :from="from"
              :to="pageData"
      />
    </div>
    <div class="ba-page-node"
        :id="all ? 'nodeAll' : null"
        :class="[`x${index.x}`, `y${index.y}`,
                `device--${selectedDevice}`,
                  { active: active && !all,
                    all,
                    trackable: isTrackable,
                    tracking: all && tracking,
                    unregistered: !pageData.thumbnail,
                    disabled: nodeDisabled,
                    hovered: hovering && !active,
                    seeall: seeAll }
                ]"
        :style="{ top: positionY, left: positionX }">
      <div v-if="!all"
          class="transition"
          :class="[`position${arrowDirection}`, { disabled: !nodeDisabled && reportShowing }]"
          :style="{ 'font-size': getStyle('transitionFont', pageData.transition) + 'px',
                    'transform': transitionGap }"
      >
        {{ pageData.transition | fixedInt(2, 1) }}%
      </div>
      <ba-tracking-funnel v-if="all &&isTrackable" :tracking="tracking" :overallSessionData="overallSessionData" :sessionRatio="sessionRatio" :isTrackingAll="isTrackingAll" @setTracking="setTracking" />
      <div class="hover-area" @mouseenter="setHover(true)" @mouseleave="setHover(false)">
        <ba-node-link v-if="!all && !isCustomNode"
                      :pageData="pageData"
                      :checkOverflowRight="false"
                      @onMouseEnter="urlHover = true"
                      @onMouseLeave="urlHover = false" />
        <ba-tracking-label v-if="all &&isTrackable" hover-text="Tracking" :ratio="sessionRatio.selectedMember + sessionRatio.selectedGuest" :is-bounce="true" @click="$emit('onShowTrackingLayer', pageData)" />
        <div v-if="!all"
            class="thumbnail--wrap"
            :class="{ 'no-thumbnail': !pageData.thumbnail,
                      'no-hover': buttonHover,
                      'processing': capturing,
                      'bookmarked': pageData.bookmark && !isCustomNode,
                      'hovering': hovering && !isCategoryHover,
                      'customNode': isCustomNode }"
            @mouseenter="hovering = true"
            @mouseleave="hovering = false"
        >

          <div class="thumbnail-area" @click="setActive(pageData.seq, pageData)">
<!--            <div class="sequence"-->
<!--                :class="{ hundred: index.x - 1 > 99,-->
<!--                          thousand: index.x - 1 > 999 }"-->
<!--                v-if="active"-->
<!--            >-->
<!--              {{ index.x - 1 }}-->
<!--            </div>-->
            <category-icon
              v-if="!all && !isCustomNode && journeyOptions.matchType !== 'exact'"
              :category="pageData.AICategory1"
              :category2="pageData.AICategory2"
              :see-all="seeAll"
              @onCategoryHover="onCategoryHover"
            />
            <div class="thumbnail-overflow">
              <template v-if="!isCustomNode">
                <div class="thumbnail" :style="{ 'background-image': `url('${pageData.thumbnail || defaultThumbnail}')` }"></div>
              </template>
              <template v-else>
                <div class="thumbnail-group">
                  <div class="background" :class="{upcoming: pageData.customId === 0}" :style="{ 'background-color': pageData.customColor }"></div>
                  <div class="group-name custom" :class="{upcoming: pageData.customId === 0}">
                    {{ pageData.customId === 0 ? $t('customTag.untaggedLabel') : pageData.customValue}}
                    <template v-if="pageData.customId === 0">
                      <br><i class="icon icon--upcoming-large"></i>
                    </template>
                  </div>
                </div>
              </template>

              <heatmap-sample v-if="isShowHeatmap && !isCustomNode" :device="selectedDevice"></heatmap-sample>
              <transition name="fade">
                <div v-if="!isCustomNode && grouping && pageData.tagInfo && pageData.tagInfo[group]">
                  <template v-if="pageData.tagInfo[group].tagId > -1">
                    <div class="thumbnail-group">
                      <div class="background" :style="{ 'background-color': pageData.tagInfo[group].colorHex }"></div>
                      <div class="group-name">
                        {{ tagName }}
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="thumbnail-group">
                      <div class="background upcoming"></div>
                      <div class="group-name upcoming">
                        {{ $t('group.upcoming') }}<br>
                        <i class="icon icon--upcoming-large"></i>
                      </div>
                    </div>
                  </template>
                </div>
              </transition>
              <transition name="fade">
                <div class="loading" v-show="capturing">
                  <span class="loading-circle">
                    <svg x="0px" y="0px" viewBox="0 0 150 150">
                      <circle class="loading-inner" cx="75" cy="75" r="60"/>
                    </svg>
                  </span>
                </div>
              </transition>
            </div>
            <div class="buttons" v-if="!isCustomNode">
              <div class="wrap">
                <button class="heatmap"
                        @click.stop="onHeatmap(pageData)"
                        @mouseenter="buttonHover = true"
                        @mouseleave="buttonHover = false"
                        v-if="isShowHeatmap">
                  <i class="icon icon--heatmap-on small"></i>
                  <span class="label"> {{ $t('common.heatmap') }}</span>
                </button>

                <button class="capture"
                        @click="onCapture(pageData)"
                        @mouseenter="buttonHover = true"
                        @mouseleave="buttonHover = false"
                        v-if="!pageData.thumbnail && !capturing">
                  <i class="icon icon--retake-white"></i>
                  <span class="label"> {{ $t('journey.screenshot') }}</span>
                </button>
              </div>
            </div>

            <div v-if="showJaamhwa" class="more-wrap">
              <div class="more has">
                <i class="icon icon--next"></i>
              </div>
            </div>

            <span v-if="!isLastX && ((pageData.children && pageData.children.length) || pageData.hasNextColumn)" class="nail"></span>

            <div class="rollback">
              <span class="text">{{ pageData.rollback | letterThousand }}%</span>
              <span v-if="getRank('rollback', pageData.rollback) === 0" class="icon-wrap icon-with-warning">
                <i class="icon icon--rollback-new size-16"></i>
                <i class="icon icon--ba-warning size-16"></i>
              </span>
              <span v-else class="icon-wrap">
                <i class="icon icon--rollback-new size-16"></i>
              </span>
            </div>
          </div>
        </div>
        <div v-else class="thumbnail--wrap">
          <div class="thumbnail" @click="tracking && $emit('onShowTrackingLayer', pageData)">
            <div :class="['match-type', journeyOptions.matchType]"
              v-btf-tooltip:top.center="{contents: journeyOptions.matchType === 'exact' ? $t('common.matchType.exactGuide') : $t('common.matchType.simpleGuide'), size: 220}"
              >
              {{ journeyOptions.matchType}}
            </div>
            <div class="thumbnail-all">
              <div v-if="isTrackable" class="tracking">
                <h4>..Tracking</h4>
                <p class="tracking-user">
                  <span class="tracking-user-label">{{ trackingStartNodeText.label }}</span>
                  <span class="tracking-user-value">{{ trackingStartNodeText.value }}</span>
                </p>
              </div>
              <h4 v-else>
                Start
                <span class="percent">100%</span>
              </h4>
            </div>
          </div>
        </div>
        <transition name="item-info">
          <div class="item-info" v-if="all || !nodeDisabled">
            <div class="item-info-container">
              <div class="item-info-wrap" @click="$emit('onShowReport', pageData)">
                <div class="left-side">
                  <div class="session">
                    <i class="icon icon--ba-session"></i>
                    <span class="count">
                      <span v-if="pageData.sessCntIsInaccurate" class="invalid-number">{{ $t('common.invalidValue') }}</span>
                      <span v-else class="number" :class="getSessionFontClass(pageData.sessCnt)">{{ getComputedSess() | letterThousandMillion(0) }}</span>
                    </span>
                  </div>

                  <div class="more-info" v-if="!all">
                    <div class="refresh">
                      <span v-if="getRank('repeat', pageData.repeat) === 0" class="icon-wrap icon-with-warning">
                        <i class="icon icon--refresh-small"></i>
                        <i class="icon icon--ba-warning"></i>
                      </span>
                      <span v-else class="icon-wrap">
                        <i class="icon icon--refresh-small"></i>
                      </span>
                      <br>
                      {{ pageData.repeat | letterThousand }}%
                    </div>

                    <div class="time">
                      <span v-if="getRank('sessionTime', pageData.sessTime) === 0" class="icon-wrap icon-with-warning">
                        <i :class="'icon icon--hourglass-small-' + getStyle('sessionTime', pageData.sessTime)"></i>
                        <i class="icon icon--ba-warning"></i>
                      </span>
                      <span v-else class="icon-wrap">
                        <i :class="'icon icon--hourglass-small-' + getStyle('sessionTime', pageData.sessTime)"></i>
                      </span>
                      <br>
                      {{ timeString }}
                    </div>
                  </div>
                </div>
                <div class="right-side" v-if="!all">
                  <div class="dropoff">
                    <span v-if="getRank('dropOff', pageData.dropOff) === 0" class="icon-wrap icon-with-warning">
                      <i :class="'icon icon--dropoff-small-' + getStyle('dropOff', pageData.dropOff)"></i>
                      <i class="icon icon--ba-warning"></i>
                    </span>
                    <span v-else class="icon-wrap">
                      <i :class="'icon icon--dropoff-small-' + getStyle('dropOff', pageData.dropOff)"></i>
                    </span>
                    <br>
                    {{ pageData.dropOff | fixedInt(2, 1)}}%
                  </div>
                  <div class="node-report" :class="[pageData.AICategory1 && pageData.AICategory1.length !== 0 && AI_CATEGORY_SECONDARY.includes(pageData.AICategory1) ? pageData.AICategory1 : 'etc']">
                    <i class="icon icon--node-report-category" />
                    <span class="node-report-text" v-if="seeAll" v-html="$t('journey.nodeReport.title')"></span>
                  </div>
                </div>
              </div>
              <ba-tracking-bar
                  v-if="!all && isTrackable"
                  :total="pageData.sessCnt"
                  :member="pageData.memberSessCnt"
                  :login="pageData.loggedInSessCnt"
                  :newLogin="pageData.newlyLoggedInSessCnt"
                  @onClick="$emit('onShowTrackingLayer', pageData)"/>
            </div>
          </div>
        </transition>

        <div class="start-node-buttons" v-if="all">
          <div
              class="targeting-button"
              :class="{
                'disabled': isUnableToTarget,
                'is-mobile': isMobile
              }"
          >
            <button type="button"
                    @click="onTargetingButtonClick">
              {{ $t('common.targets') }}
              <ui-tooltip arrowCenter>
                <span v-html="$t('journey.targeting.setting')"></span>
              </ui-tooltip>
            </button>
            <div v-if="isUnableToTarget" class="disabled-info">
              <i class="icon icon--info"></i>
              <ui-tooltip arrowCenter>
                <span v-html="$t('journey.targeting.disabledInfo')"></span>
              </ui-tooltip>
            </div>
          </div>
          <button class="start-node-button best-journey-btn" :class="[{on: mostOccurred}]" @click="$emit('onSearchJourney')" @touchstart="$emit('onSearchJourney')">
            <i class="icon icon--ai-purple" />
            <div class="text-contents" v-html="$t('journey.mostOccurred.btnLabel')"></div>
            <transition name="slide-fade">
              <div class="best-journey-tooltip">
                <template v-if="mostOccurred">
                  <div v-html="$t('journey.mostOccurred.tooltip.activated', { value: `${mostOccurredValue}` })"></div>
                </template>
                <template v-else>
                  <div v-html="$t('journey.mostOccurred.tooltip.hovered')"></div>
                </template>
              </div>
            </transition>
          </button>
          <button class="start-node-button ai-report" :disabled="!ableToShowAiReport" @click="onClickAiReport">
            <i class="icon icon--ai-blue" />
            <span class="text-contents">Report</span>
          </button>
          <a v-if="!isExactMatchType" class="ai-categorize-btn" :href="categoryLegendLink" target="_blank">
            <span>{{ $t('journey.aiCategorize') }}</span>
            <i class="icon icon--tooltip-link"></i>
          </a>
          <ai-referrer-summary class="ai-referrer-summary" />
        </div>

        <div class="custom-button" v-if="all && isCustomNodeAvailable">
            <span class="label">
                      {{ $t('customTag.label') }}
                    </span>
          <ba-switch :value="isCustomNode"
                     :default="isCustomNode"
                     :width="44"
                     :size="'small'"
                     :disabled="isCustomDisabled"
                     v-btf-tooltip:top.start="{contents: isCustomDisabled ? $t('customTag.disabled', { date: customRegDate }) : ''}"
                     @change="onCustomTag" />
        </div>
      </div>

      <template v-if="!all">
        <transition name="more-x">
          <button v-if="showMoreX" class="more-x" @click="setActive(pageData.seq, pageData, true)">
            <i class="icon icon--more-x"></i>
          </button>
        </transition>
        <transition name="more-y">
          <button v-if="showMoreY" class="more-y" @click="getMoreSibling(pageData, from)">
            <i class="icon icon--more-y"></i>
          </button>
        </transition>
      </template>

      <slot></slot>
    </div>

    <transition name="slide-fade">
      <div class="children" v-if="showChildren">
        <ba-page-node
            v-for="pageNode in pageData.children"
            :key="`${pageNode.key}:${pageNode.index.x}:${pageNode.index.y}`"
            :itemDistance="itemDistance"
            :index="pageNode.index"
            :indexMax="indexMax"
            :indexShow="indexShow"
            :hovered="hovered"
            :activated="activated"
            :ratioOption="ratioOption"
            :selected="selected"
            :reportShowing="reportShowing"
            :captureProcessing="captureProcessing"
            :seeAll="seeAll"
            :pageData="pageNode"
            :from="pageData"
            :valueRange="valueRange"
            :sibling="pageData.children"
            :defaultThumbnail="defaultThumbnail"
            :pluckTreeInfo="pluckTreeInfo"
            :isTrackable="isTrackable"
            :tracking="tracking"
            :grouping="grouping"
            :group="group"
            :mostOccurred="mostOccurred"
            :overallSessionData="overallSessionData"
            @onShowReport="$emit('onShowReport', $event)"
            @onResetActive="$emit('onResetActive')"
            @onCapture="onCapture($event)"
            @onMoreSibling="(page, parent) => getMoreSibling(page, parent)"
            @onHeatmap="onHeatmap"
            @onActivePageNode="setActive"
            @onHoverPageNode="setChildHover"
            @currentMax="setCurrentMax"
            @onShowTrackingLayer="$emit('onShowTrackingLayer', $event)"
          >
        </ba-page-node>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { JOURNEY_TARGETING_VIEWABLE_START_DATE } from '@/store'
import { EventBus } from '@/libs/event-bus'
import { onlySubdomain, uiClearTextSelection, getTimeString, utcToLocalTimezone, thousand } from '@/libs/utils'
import { create } from 'vue-modal-dialogs'
import browser from '@/libs/browser'

import UiTooltip from '@/components/ui/UiTooltip'
import AppDialog from '@/components/ui/AppDialog.vue'
import BaPageNode from '@/components/journey/PageNode'
import BaPageNodeArrow from '@/components/journey/PageNodeArrow'
import BaNodeLink from '@/components/trend/NodeLink'
import { HEATMAP_STATE, AI_CATEGORY_SECONDARY } from '@/libs/constants'
import { differenceInDays, format } from 'date-fns'
import HeatmapSample from '@/components/heatmap/HeatmapSample.vue'
import CategoryIcon from '@/components/journey/CategoryIcon.vue'
import BaTrackingLabel from '@/components/journey/TrackingLabel.vue'
import BaSwitch from '@/components/ui/ba/Switch.vue'
import BaTrackingFunnel from '@/components/journey/TrackingFunnel.vue'
import BaTrackingBar from '@/components/journey/TrackingBar.vue'
import AiReferrerSummary from '@/components/report/AiReferrerSummary.vue'

const openDialog = create(AppDialog)

export default {
  name: 'BaPageNode',
  components: {
    AiReferrerSummary,
    BaSwitch,
    CategoryIcon,
    HeatmapSample,
    UiTooltip,
    BaPageNode,
    BaPageNodeArrow,
    BaNodeLink,
    BaTrackingLabel,
    BaTrackingFunnel,
    BaTrackingBar
  },
  computed: {
    ...mapState([
      'journeyOptions',
      'journeyPeriod',
      'journeyPluck',
      'numBookmarks',
      'domain',
      'isSampling',
      'isDemo',
      'journeyTargetingOptions'
    ]),
    isExactMatchType () {
      return this.domain.matchType === 'exact' || this.journeyOptions.matchType === 'exact'
    },
    isCustomNode () {
      return this.journeyOptions.isCustomNode
    },
    isCustomNodeAvailable () {
      if (!this.customRegDate || this.journeyOptions.matchType === 'exact') {
        return false
      }
      return !(this.customRegDate > this.journeyPeriod.start && this.customRegDate > this.journeyPeriod.end)
    },
    isCustomDisabled () {
      if (this.isCustomNodeAvailable) {
        return this.journeyPeriod.start < this.customRegDate && this.customRegDate <= this.journeyPeriod.end
      } else {
        return true
      }
    },
    customRegDate () {
      const beuCustomRegDateStr = this.domain.beuCustomRegDate ? format(this.domain.beuCustomRegDate, 'YYYY-MM-DD') : null
      return beuCustomRegDateStr
    },
    isSurvey () {
      return this.journeyOptions.survey
    },
    device () {
      return this.journeyOptions.device
    },
    selectedDevice () {
      return this.device || 'all'
    },
    captureDevice () {
      return this.device || 'desktop'
    },
    tagName () {
      return onlySubdomain(this.pageData.tagInfo[this.group].tagName, this.journeyOptions.domain)
    },
    capturing () {
      if (this.isExactMatchType) {
        return this.captureProcessing && this.captureProcessing.key === this.pageData.key
      } else {
        return this.captureProcessing && this.captureProcessing.urlId === this.pageData.key
      }
    },
    arrowDisabled () {
      return this.reportShowing ||
        (this.selected && this.selected.seq >= this.pageData.seq && !this.active)
    },
    nodeDisabled () {
      // return (this.reportShowing && (this.reportShowing.id !== this.pageData.id || (this.selected && this.selected.id !== this.pageData.id))) ||
      // (this.selected && this.selected.seq >= this.pageData.seq && !this.active)
      return (this.reportShowing && (this.reportShowing.id !== this.pageData.id || (this.selected && this.selected.id.indexOf(this.pageData.id) < 0))) ||
        (this.selected && !this.active) || (this.mostOccurred && !this.active)
    },
    transitionGap () {
      if (this.arrowDirection === 2) {
        return `translateY(-${this.getStyle('transition', this.pageData.transition) / 2}px)`
      } else {
        const diffFrom = Math.abs((this.from.index ? this.from.index.y : 1) - this.pageData.index.y)
        const goDown = this.arrowStart < this.arrowEnd
        return `translateX(${-1 * ((-this.getStyle('transition', this.pageData.transition) / 2) - (diffFrom * (this.indexMax.y * -0.01) * (goDown ? -2 : 2)) - (goDown ? 4 : 25) - ((10 - this.indexMax.y) * -1.5) + (this.indexMax.y * (goDown ? 0.7 : 1.5)) - 1 + (this.active ? 5 : 0))}px)`
      }
    },
    arrowWidth () {
      return this.itemDistance.x - 226 + this.arrowActiveGap - (this.arrowStartGap - 113) - (this.active ? 10 : 0)
    },
    arrowHeight () {
      return this.itemDistance.y * this.indexMax.y
    },
    arrowStart () {
      let gap = -(this.transitionWeight - this.siblingWeight.weight) / 2
      if (this.from.index && this.from.index.y === this.index.y) {
        gap = 0
      } else if (!this.from.index || (this.from.index.y < this.index.y || this.from.index.y > this.siblingWeight.idxY)) {
        gap = -gap
      }
      return 20 + ((this.from.index ? this.from.index.y - 1 : 0) * this.itemDistance.y) - gap
    },
    arrowEnd () {
      return 20 + this.itemDistance.y * (this.index.y - 1)
    },
    arrowTime () {
      if (!this.active) {
        return 0
      }
      return 2 / this.arrowWidth * (Math.abs(this.arrowEnd - this.arrowStart) / 2 + this.arrowWidth)
    },
    arrowDirection () {
      const fromY = (this.from.index ? this.from.index.y : 1)
      if (fromY === this.pageData.index.y) {
        return 2
      } else if (fromY > this.pageData.index.y) {
        return 3
      } else {
        return 1
      }
    },
    isLastX () {
      return this.index.x >= this.indexShow.x
    },
    isLastY () {
      if (this.mostOccurred) {}
      return this.index.y >= this.from.children.length
    },
    showJaamhwa () {
      if (this.showMoreX) {
        return false
      }
      return (!this.active || this.isLastX) && ((this.pageData.children && this.pageData.children.length) || this.pageData.hasNextColumn)
    },
    showMoreY () {
      if (!this.isLastY || !this.from || !this.from.children) {
        return false
      }

      return this.from.hasMoreChildren
    },
    showMoreX () {
      if (this.showChildren || !this.active) {
        return false
      }
      return this.pageData.hasNextColumn && !this.pageData.children
    },
    showChildren () {
      if (this.isMostOccurredMaxDepth) {
        return false
      }
      return this.pageData.children && this.pageData.children.length > 0 && this.active
    },
    isMostOccurredMaxDepth () {
      return this.mostOccurred && this.pageData.seq >= 3
    },
    arrowActiveGap () {
      if (!this.active) {
        return 3
      }
      return 0
    },
    arrowStartGap () {
      switch (this.selectedDevice) {
        case 'all':
          return 92
        case 'desktop':
          return 113
        case 'tablet':
          return 35
        default:
          return 5
      }
    },
    transitionWeight () {
      return this.getStyle('transition', this.pageData.transition)
    },
    siblingWeight () {
      let siblingWeight = this.transitionWeight
      let siblingIdxY = this.index.y
      for (let sibling of this.sibling) {
        if (!sibling || !sibling.index) {
          continue
        }
        let weight = this.getStyle('transition', sibling.transition)
        if (weight > siblingWeight) {
          siblingWeight = weight
          siblingIdxY = sibling.index.y
        }
      }
      return { idxY: siblingIdxY, weight: siblingWeight }
    },
    active () {
      return this.activated[this.pageData.seq] && this.activated[this.pageData.seq].key === this.pageData.key
    },
    timeString () {
      return getTimeString(this.pageData.sessTime)
    },
    positionX () {
      return this.itemDistance.x * (this.index.x - 1) + this.itemDistance.first.x + 'px'
    },
    positionY () {
      return this.itemDistance.y * (this.index.y - 1) + this.itemDistance.first.y + 'px'
    },
    journeyTargetingViewableStartTime () {
      return new Date(JOURNEY_TARGETING_VIEWABLE_START_DATE).getTime()
    },
    isUnableToTarget () {
      return this.journeyTargetingViewableStartTime > new Date(this.journeyPeriod.end).getTime()
    },
    isMobile () {
      return browser.isMobile
    },
    isHeatmapAvailableRange () {
      const start = this.journeyPeriod.start
      const end = this.journeyPeriod.end
      const startDate = new Date(start)
      const endDate = new Date(end)

      const diffDay = differenceInDays(endDate, startDate) + 1
      return diffDay <= 31
    },
    categoryLegendLink () {
      switch (this.$i18n.locale) {
        case 'ko':
          return 'https://forum.beusable.net/ko/solomon/post/2136'
        case 'ja':
          return 'https://forum.beusable.net/ja/solomon/post/2221'
        case 'en':
          return 'https://forum.beusable.net/en/solomon/post/2220'
      }
      return 'https://forum.beusable.net/ko/solomon/post/2136'
    },
    showMostOccurred () {
      return this.mostOccurred && this.pageData.seq <= 3
    },
    sessionRatio () {
      const { memberSessCnt, sessCnt } = this.overallSessionData
      const allMember = memberSessCnt / sessCnt
      const allGuest = 1 - allMember

      return {
        allMember,
        allGuest,
        selectedMember: this.tracking ? this.tracking.type === 'member' ? this.pageData.memberSessCnt / sessCnt : 0 : allMember,
        selectedGuest: this.tracking ? this.tracking.type === 'guest' ? (this.pageData.sessCnt - this.pageData.memberSessCnt) / sessCnt : 0 : allGuest
      }
    },
    isTrackingAll () {
      if (!this.tracking) return false
      if (this.tracking.type === 'member') {
        return this.overallSessionData.memberSessCnt === this.pageData.sessCnt
      } else {
        return this.overallSessionData.sessCnt - this.overallSessionData.memberSessCnt === this.pageData.sessCnt
      }
    },
    trackingStartNodeText () {
      const trackingInfo = {}
      if (this.isTrackable) {
        if (this.tracking && this.tracking.type === 'guest') {
          trackingInfo.value = this.$t('tracking.guest')
        } else {
          if (this.tracking && this.pageData.memberCnt === 1) {
            trackingInfo.value = this.tracking.selectedMembers[0].displayId
          } else {
            trackingInfo.label = this.$t('tracking.member')
            trackingInfo.value = thousand(this.pageData.memberCnt)
          }
        }
      }
      return trackingInfo
    },
    AI_CATEGORY_SECONDARY () {
      return AI_CATEGORY_SECONDARY
    },
    ableToShowAiReport () {
      return (!this.domain.shared || this.domain.shared === 'share') && !this.journeyOptions.isCustomNode && !this.tracking && this.journeyOptions.device
    }
  },
  watch: {
  },
  created () {
    this.onCheckHeatmap()
  },
  mounted () {
    if (!this.showChildren) {
      this.$emit('currentMax', this.index)
    }
  },
  methods: {
    ...mapMutations([
      'setJourneyTargetingOptions',
      'setBookmarkListLayerOptions'
    ]),
    onCustomTag () {
      this.$emit('onCustomTag')
    },
    setCurrentMax (value) {
      this.$emit('currentMax', value)
    },
    onHeatmap (pageData) {
      this.$emit('onHeatmap', pageData)
    },
    onCheckHeatmap () {
      if (!this.isHeatmapAvailableRange) {
        this.isShowHeatmap = false
        return false
      }

      if (!this.pageData.baApply || !this.pageData.heatmapAid) {
        this.isShowHeatmap = false
        return false
      }

      if (this.pageData.heatmapUiState === HEATMAP_STATE.ANALYZING) {
        this.isShowHeatmap = false
        return false
      }

      const installDate = this.pageData.baApply.installDate
      if (installDate) {
        const installDateStr = format(utcToLocalTimezone(installDate, this.domain.timezoneName), 'YYYY-MM-DD')

        if (this.journeyPeriod.end < installDateStr) {
          this.isShowHeatmap = false
          return false
        }
      } else {
        this.isShowHeatmap = false
        return false
      }

      if (this.pageData.isExistHeatmap) {
        this.isShowHeatmap = true
        return false
      }
    },
    getComputedSess () {
      return this.pageData.sessCntIsInaccurate ? this.$t('common.invalidValue') : this.pageData.sessCnt
    },
    getSessionFontClass (session) {
      if ((session > 99999 && session <= 99999999) || (session > 999999999 && session <= 9999999999) || session > 999999999999) {
        return 'small'
      }
      return null
    },
    getRank (type, value) {
      return [...this.valueRange[type]].reverse().indexOf(value)
    },
    onCapture (pageData = null) {
      if (this.isDemo) return false
      if (!pageData) {
        pageData = this.pageData
      }
      this.$emit('onCapture', pageData, this.captureDevice)
    },
    openNewWindow (url) {
      if (this.active) {
        window.open(url)
      }
    },
    getTopPosition (type, value) {
      if (this.valueRange[type] && this.valueRange[type].length) {
        const max = this.valueRange[type][this.valueRange[type].length - 1]
        const min = this.valueRange[type][0]
        if (value === max) {
          return 0.999999
        }
        if (max !== min) {
          const result = (value - min) / (max - min)
          if (result < 0) {
            return 0
          }
          return result || 0
        } else {
          return 0.999999
        }
      }
      return 0
    },
    getStyle (type, value) {
      let percent = this.getTopPosition(type.replace('Font', ''), value) * this.topStyle[type].length
      return this.topStyle[type][Math.floor(percent || 0)]
    },
    setChildHover (data) {
      this.$emit('onHoverPageNode', data)
    },
    setHover (value) {
      if (value) {
        this.$emit('onHoverPageNode', {
          focus: this.pageData,
          from: this.from,
          to: this.pageData.children
        })
      } else {
        uiClearTextSelection()
        this.$emit('onHoverPageNode', null)
      }
    },
    setActive (seq, page = null, loadMore = false, setSelected = true, gUrlIdList) {
      uiClearTextSelection()
      if (this.from && (!gUrlIdList || gUrlIdList.length === 0)) {
        gUrlIdList = []
      }
      if (this.from) {
        gUrlIdList.unshift(this.pageData.key)
      }
      this.$emit('currentMax', this.index)
      // if (!loadMore && !this.from) {
      //   console.log(111)
      //   this.$emit('onHeatmapView', seq, page, gUrlIdList)
      // }
      this.$emit('onActivePageNode', seq, page, loadMore, true, gUrlIdList)
    },
    getMoreSibling (page, parent) {
      this.$emit('onMoreSibling', page, parent)
    },
    onSettingUtm (tag) {
      EventBus.$emit('settingUtm', true, tag)
    },
    async onTargetingButtonClick () {
      if (this.tracking) {
        const confirmed = await openDialog({
          dialogType: 'tracking.stopTrackingWithDesc',
          optionContent: { style: 'height: 14px;' }
        })
        if (!confirmed) return
      }

      const startDate = new Date(this.journeyPeriod.start).getTime()
      if (this.journeyTargetingViewableStartTime > startDate) {
        this.setJourneyTargetingOptions('start-date-is-not-viewable')
        return
      }

      if (this.numBookmarks < 1) {
        this.setBookmarkListLayerOptions({ mode: 'guide' })
      } else {
        this.setBookmarkListLayerOptions(true)
      }
    },
    onCategoryHover (isShow) {
      this.isCategoryHover = isShow
    },
    setTracking (type) {
      const data = {
        init: this.tracking && this.tracking.type !== type,
        type: type === 'member' ? 'guest' : 'member',
        isAllSelected: true,
        isFromFunnel: true,
        selectedMembers: [],
        excludedMembers: []
      }

      if (this.tracking && this.tracking.type === type && !this.isTrackingAll) {
        data.type = type
      }

      this.$emit('setTracking', data)
    },
    onClickAiReport () {
      if (!this.ableToShowAiReport) return
      EventBus.$emit('setSegmentPayment')
    }
  },
  props: {
    all: {
      type: Boolean,
      default: false
    },
    ratioOption: {
      type: String,
      default: 'Overall flow'
    },
    seeAll: {
      type: Boolean,
      default: false
    },
    pageData: {
      required: true
    },
    indexMax: {},
    indexShow: {},
    itemDistance: {},
    index: {},
    hovered: {},
    activated: {},
    selected: {},
    reportShowing: {},
    captureProcessing: {},
    from: {},
    valueRange: {},
    sibling: {},
    defaultThumbnail: {
      default: null
    },
    pluckTreeInfo: {
      default: null
    },
    tracking: {
      default: null
    },
    isTrackable: {
      default: false
    },
    grouping: {},
    group: {},
    mostOccurred: {
      type: Boolean,
      default: false
    },
    mostOccurredValue: {
      type: String,
      default: null
    },
    overallSessionData: {
      default: () => ({
        memberSessCnt: 0,
        sessCnt: 0
      })
    }
  },
  data () {
    return {
      tagList: [
        'source',
        'medium',
        'campaign',
        'term',
        'content'
      ],
      buttonHover: false,
      urlHover: false,
      to: null,
      topStyle: {
        transition: [4, 5, 7, 11, 24],
        transitionFont: [12, 12, 13, 13, 14],
        dropOff: [3, 2, 1],
        sessionTime: [1, 2, 3]
      },
      hovering: false,
      isShowHeatmap: false,
      isOpenHeatmap: false,
      isCategoryHover: false
    }
  }
}
</script>

<style lang="scss" scoped>
.ba-page-node-arrow {
  position: absolute;
  z-index: -1;
}

.ba-page-node {
  position: absolute;
  transform: translate(-50%, -50%);
  width: 195px;
  height: 122px;
  transition: width 0.2s ease,
              height 0.2s ease,
              opacity 0.2s ease,
              box-shadow 0.2s ease;
  border-radius: 10px;
  z-index: 3;

  .transition {
    position: absolute;
    font-size: 13px;
    color: #88a917;
    bottom: 143px;
    left: -53px;
    overflow: hidden;
    transition: opacity 0.3s ease,
                transform 0.3s ease,
                bottom 0.3s ease,
                left 0.3s ease;

    &.position2 {
      text-align: center;
      width: 50px;
      left: -78px;
      bottom: 65px !important;
    }

    &.position3 {
      left: -63px !important;
      bottom: -35px !important;
    }

    &.disabled {
      opacity: 0.3;
    }
  }

  .hover-area {
    width: 100%;
    height: 100%;
  }

  &.active {
    .transition {
      color: #0e90a5;
    }
  }

  .favorite {
    position: absolute;
    top: -23px;
    left: -14px;
    transition: top 0.2s ease, left 0.2s ease;
  }

  .link-wrap {
    left: 5px;
    right: 7px;
    top: -25px;
    color: #555;
    transform: none;
  }

  .tracking-label {
    position: absolute;
    top: 8px;
    left: -29px;
    z-index: 5;
  }

  .thumbnail--wrap {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    position: relative;
    background-color: #ffffff;
    display: inline-block;
    padding: 4px;
    box-sizing: border-box;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.05);
    transition: box-shadow 0.2s ease,
                opacity 0.3s ease,
                width 0.2s ease,
                height 0.2s ease;
    cursor: pointer;

    &:after {
      position: absolute;
      left: 4px;
      top: 4px;
      width: 43px;
      height: 43px;
      content: '';
      text-indent: -999em;
      background: url('../../assets/img/targeting/icon--bookmark-ribbon.svg') no-repeat 0 0 / 100%;
      overflow: hidden;
      opacity: 0;
      transition: opacity 0.1s ease-out;
    }

    &.bookmarked:after {
      content: 'Bookmarked';
      opacity: 1;
    }

    .buttons {
      position: absolute;
      top: 8px;
      left: 8px;
      z-index: 2;
      opacity: 0;
      transition: opacity 0.2s ease;

      .wrap {
        padding-bottom: 39px;
      }

      button {
        border-radius: 4px;
        white-space: nowrap;
        position: relative;
        z-index: 2;
        padding: 3px 3px 3px 3px;
        text-align: left;
        transition: background-color 0.2s ease;

        .icon {
          vertical-align: middle;
        }

        &.heatmap {
          & .label {
            top: 0;
          }
        }

        .label {
          position: relative;
          top: -1px;
          z-index: 2;
          cursor: pointer;
          color: #ffffff;
          overflow: hidden;
          display: inline-block;
          max-width: 0;
          transition: max-width 0.2s ease, margin 0.2s ease;
          vertical-align: middle;
          margin: 0;
        }

        &:hover {
          .label {
            max-width: 100px;
            margin: 0 5px 0 4px;
          }
        }

        &.heatmap {
          margin-right: 4px;
          background-color: #272727;
        }

        &.capture {
          background-color: #272727;
        }
      }
    }

    &.no-thumbnail {
      &:not(.processing)::before {
        @include positionXYcenter;
        z-index: 1;
        content: "";
        background: url('../../assets/img/journey/icon_add_image.svg') no-repeat center center;
        width: 50px;
        height: 50px;
        transition: opacity 0.2s ease;
      }
    }

    &.customNode {
      &::before {
        background: initial !important;
      }
    }

    .loading {
      position: absolute;
      top: calc(50% - 27px);
      left: calc(50% - 19px);
      padding: 7px;
      border-radius: 8px;
      background-color: #ffffff;
      width: 24px;
      height: 24px;

      .loading-circle {
        position: absolute;
        width: 24px;
        height: 24px;
        transform: translate(-50%, -50%);
        animation: loading 3s linear infinite;
        transition: opacity 0.3s ease;

        svg {
          height: 100%;
        }

        .loading-inner {
          stroke: {
            dashoffset: 0;
            dasharray: 300;
            width: 20;
            miterlimit: 10;
            linecap: round;
          }

          animation: loading-circle 2s linear infinite;
          stroke: $brandColor;
          fill: transparent;
        }
      }
    }

    @keyframes loading {
      0% {
        transform: rotate(0);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    @keyframes loading-circle {
      0% {
        stroke-dashoffset: 0
      }
      100% {
        stroke-dashoffset: -600;
      }
    }

    .thumbnail-area {
      width: 100%;
      height: 100%;
    }

    .thumbnail-overflow {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      border-radius: 8px;
    }

    .more-wrap {
      @include positionYcenter;
      right: 0;
      width: 0;
      height: 33px;
      padding-left: 3px;
      z-index: -1;
      overflow: hidden;
      transition: right 0.2s ease, width 0.2s ease;

      .more {
        position: absolute;
        right: 0;
        height: 33px;
        width: 28px;
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
        transition: background-color 0.2s ease;

        .icon {
          @include positionXYcenter;
          width: 15px;
          height: 15px;
          background-size: cover;
        }
      }
    }

    &.hovering {
      box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 0 0 3px #0074ff !important;

      .rollback {
        opacity: 0;
      }

      .buttons {
        opacity: 1;
      }

      &.no-thumbnail {
        .buttons::before {
          opacity: 0;
        }
      }

      .nail {
        border-left-color: #0074ff !important;
      }

      .more-wrap {
        right: -30px;
        width: 28px;

        .more {
          background-color: #d7d7d7;

          &.has {
            background-color: #0074ff;
          }
        }
      }

      &.no-hover {
        box-shadow: none;

        .more-wrap {
          right: 0;
        }
      }
    }

    &:not(:hover) {
      user-select: none;
    }
  }

  .more-x {
    @include positionYcenter;
    right: -62px;
    transition: right 0.2s ease,
    box-shadow 0.2s ease,
    opacity 0.2s ease;
    z-index: 1;
    box-shadow: 0 5px 6px -2px rgba(0, 0, 0, 0.22), 0 0 0 1px rgba(0, 0, 0, 0.15);
    background-color: #ffffff;
    width: 41px;
    height: 41px;
    padding: 8px;
    border-radius: 21px;

    &:hover {
      box-shadow: 0 5px 6px -2px rgba(0, 0, 0, 0.22), 0 0 0 2px rgba(0, 116, 255, 1);
    }
  }

  &.hovered {
    .more-x {
      right: -84px;
    }
  }

  .more-y {
    @include positionXcenter;
    bottom: -89px;
    transition: box-shadow 0.2s ease,
    opacity 0.2s ease;
    box-shadow: 0 5px 6px -2px rgba(0, 0, 0, 0.22), 0 0 0 1px rgba(0, 0, 0, 0.15);
    background-color: #ffffff;
    width: 37px;
    height: 37px;
    padding: 6px;
    border-radius: 21px;

    &:hover {
      box-shadow: 0 5px 6px -2px rgba(0, 0, 0, 0.22), 0 0 0 2px rgba(0, 116, 255, 1);
    }
  }

  &.more-x-enter-active,
  &.more-x-leave-active,
  &.more-y-enter-active,
  &.more-y-leave-active {
    opacity: 1;
  }

  &.more-x-enter,
  &.more-x-leave-to,
  &.more-y-enter,
  &.more-y-leave-to {
    opacity: 0;
  }

  .thumbnail {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: top center;
    border-radius: 8px;

    &::after {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.15);
      border-radius: 8px;
    }
  }

  .thumbnail-group {
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100% - 66px);
    height: calc(100% - 76px);
    padding: 16px 52px 60px 14px;
    border-radius: 8px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    font-weight: bold;
    line-height: 1.3;
    color: #fff;

    .background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0.8;

      &.upcoming {
        background-color: rgb(187, 187, 187);
        opacity: 0.9;
      }
    }

    .group-name {
      position: relative;
      display: -webkit-box;
      word-break: break-all;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      font-size: 17px;
      line-height: 22px;
      padding-right: 10px;

      &.upcoming {
        font-size: 17px;
        line-height: 22px;
        word-break: keep-all;
        overflow: visible;
        line-clamp: initial;
        -webkit-line-clamp: initial;

        .icon {
          margin-top: 6px;
        }
      }
    }
  }

  .sequence {
    position: absolute;
    top: 50%;
    left: -13px;
    transform: translateY(-50%);
    width: 26px;
    height: 26px;
    text-align: center;
    line-height: 26px;
    border-radius: 5px;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.8);
    background-color: #333333;
    z-index: 5;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;

    &.hundred {
      font-size: 12px;
    }

    &.thousand {
      font-size: 11px;
    }

    & /deep/ .thumbnail-group {
      display: none;
    }
  }

  .rollback {
    position: absolute;
    top: 17px;
    right: -20px;
    z-index: 2;
    border-radius: 4px;
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2), 0 0 4px 0 rgba(0, 0, 0, 0.12);
    background-color: #ffffff;
    font-size: 13px;
    font-weight: 500;
    color: #9665e3;
    padding: 5px 5px 5px 8px;
    text-transform: uppercase;
    transition: padding 0.2s ease,
                opacity 0.2s ease;

    // .icon {
    //   vertical-align: middle;
    // }

    .text {
      margin-right: 3px;
      vertical-align: middle;
    }
  }

  .item-info {
    position: absolute;
    left: 50%;
    bottom: -27px;
    width: 179px;
    height: 50px;
    z-index: 2;
    border-radius: 6px;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.05);
    background-color: #ffffff;
    background-size: 28px 28px;
    cursor: pointer;
    transform: translate(-50%, 0);
    transition: opacity 0.3s ease,
                box-shadow 0.2s ease,
                transform 0.2s ease,
                width 0.2s ease,
                height 0.2s ease,
                bottom 0.2s ease,
                background-position 0.2s ease;

    .item-info-container {
      position: relative;
      width: 100%;
      height: 100%;
    }

    .item-info-wrap {
      width: 100%;
      height: 100%;
      overflow: hidden;
      white-space: nowrap;
    }

    .arrow {
      position: absolute;
      z-index: 5;
      bottom: -1px;
      right: -1px;
      padding: 0;
      border-bottom-right-radius: 6px;
      background: url('../../assets/img/journey/infobox-bg.svg') transparent no-repeat right -14px bottom -14px;
      transition: width 0.2s ease,
                  height 0.2s ease,
                  padding 0.2s ease,
                  background-position 0.2s ease;

      .icon {
        transform: translate(1px, 1px);
      }
    }

    .left-side {
      position: relative;
      z-index: 2;
      display: inline-block;
      vertical-align: top;
      height: 100%;
      width: 129px;
      transition: 0.2s ease;
      transform: translateX(0);

      .more-info {
        padding-left: 6px;
      }
    }

    .right-side {
      position: relative;
      z-index: 2;
      display: inline-block;
      vertical-align: top;
      height: 100%;
      border-left: 1px solid #e7e7e7;
      width: 49px;
      text-align: center;
      transition: 0.2s ease;
      transform: translateX(0);
    }

    .session {
      color: #0e90a5;
      font-size: 13px;
      text-align: left;
      width: 82px;
      transition: width 0.2s ease,
                  padding 0.2s ease;
      padding: 14px 0 17px 9px;

      .icon {
        vertical-align: middle;
        margin-right: 6px;
        transition: transform 0.2s ease;
        transform: translateY(1px);
      }

      .count {
        display: inline-block;
        vertical-align: middle;

        .number {
          font-size: 17px;
          display: block;
          font-weight: 500;
          line-height: 18px;
          margin-top: 1px;

          &.small {
            transform: translateY(-0.5px);
            font-size: 12px;
          }
        }
        .invalid-number {
          color: #444;
          font-size: 12px;
          font-weight: 400;
        }
      }
    }

    .dropoff {
      position: relative;
      display: inline-block;
      width: 100%;
      color: #ff4a00;
      font-size: 12px;
      height: 100%;
      text-align: center;
      transition: width 0.2s ease,
                  padding-top 0.2s ease;
      padding-top: 12px;
    }

    .node-report {
      position: absolute;
      top: 0;
      left: 102%;
      z-index: 2;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 2px;
      height: 100%;
      width: 100%;
      color: #222;
      text-align: center;
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
      transition: .5s;
    }

    .node-report-text {
      width: 37px;
      text-align: center;
      // white-space: normal;
      font-size: 12px;
      &:lang(ja) {
        font-size: 0.95em;
      }
    }

    .refresh {
      position: relative;
      white-space: nowrap;
      color: #0074ff;
      font-size: 12px;
      text-align: center;
      display: inline-block;
      width: calc(50% - 1px);

      .icon-with-warning {
        margin-right: 1px;
      }

      .icon {
        margin-top: -1px;
        vertical-align: middle;
      }

      &::after {
        content: "";
        position: absolute;
        top: 3px;
        right: 0;
        background: #e3e3e3;
        width: 1px;
        height: 28px;
      }
    }

    .time {
      position: relative;
      white-space: nowrap;
      color: #4b8f0d;
      font-size: 12px;
      text-align: center;
      display: inline-block;
      height: 28px;
      width: 50%;

      .icon-with-warning {
        margin-right: 1px;
      }

      .icon {
        margin-top: -1px;
        vertical-align: middle;
      }
    }

    &.item-info-enter,
    &.item-info-leave-to {
      opacity: 0;
      transform: translate(-50%, 20px);
    }
  }

  .custom-button {
    position: absolute;
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 8px;
    left: 50%;
    top: -21px;
    z-index: 5;
    transform: translate(-50%, -100%);

    & > span {
      flex: 1;
      display: inline-flex;
      align-items: center;
      white-space: nowrap;
      position: relative;
      color: #7D7D7D;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 12px; /* 100% */
    }

    & > .ba-switch {
      position: relative;
      display: inline-block;
    }
  }

  .ai-referrer-summary {
    margin: 2px 0 0 50%;
    transform: translateX(-50%);
  }

  .start-node-buttons {
    position: absolute;
    left: 50%;
    top: calc(100% + 16px);
    width: 100%;
    transform: translate(-50%, 0);
    display: flex;
    flex-direction: column;
    gap: 6px;
    z-index: 2;
  }

  .targeting-button {
    margin-left: 56px;
    &.disabled {
      button {
        opacity: 0.3;
        pointer-events: none;
      }
    }

    .bubble {
      left: 50%;
      padding-left: 20px;
      padding-right: 20px;
      transform: translate(-50%, 10px);
      opacity: 0;
      pointer-events: none;
      transition: transform 0.2s ease, opacity 0.2s ease;

      & /deep/ .text {
        display: block;
      }
    }

    &:not(.is-mobile) button:hover .bubble,
    .disabled-info:hover .bubble {
      opacity: 1;
      transform: translate(-50%, 0);
    }

    button {
      position: relative;
      font-size: 12px;
      font-weight: 500;
      color: #555;
      line-height: 28px;
      padding: 0 8px 0 28px;
      background: #fff url('../../assets/img/targeting/icon--targeting.svg') no-repeat 4px 4px / 20px;
      box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 3px 4px -2px rgba(0, 0, 0, 0.12);
      border-radius: 6px;

      &:before {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        content: '';
        border-radius: inherit;
        background-color: rgba(0, 0, 0, 0.06);
        opacity: 0;
        transition: opacity 0.15s ease-out;
      }

      &:hover:before {
        opacity: 1;
      }

      .bubble {
        bottom: calc(100% + 9px);
      }
    }

    .disabled-info {
      position: absolute;
      left: 100%;
      top: 0;
      cursor: pointer;

      .icon {
        width: 28px;
        height: 28px;
        background-size: 18px;
      }

      .bubble {
        bottom: calc(100% + 4px);
      }
    }
  }

    .start-node-button {
      display: flex;
      align-items: center;
      gap: 4px;
      width: fit-content;
      padding: 4px 10px 4px 4px;
      margin-left: 56px;
      border-radius: 6px;
      background-color: #fff;
      box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 3px 4px -2px rgba(0, 0, 0, 0.12);
      color: #555;
      cursor: pointer;
      .text-contents {
        min-width: 41px;
        font-size: 12px;
        font-weight: 500;
        text-align: center;
      }
      &:hover {
        background-color: rgba(0, 0, 0, 0.06);
      }
      &:disabled {
        opacity: 0.3;
        pointer-events: none;
      }
    }

      .best-journey-btn {
        position: relative;
        .best-journey-tooltip {
          display: none;
          position: absolute;
          width: 192px;
          bottom: 0;
          left: 50%;
          transform: translate(-50%, calc(100% + 10px));
          background-color: #fff;
          border: 1px solid #BABABA;
          box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.16);
          color: #444;
          padding: 16px 21px;
          border-radius: 10px;
          transition: transform 500ms;
          z-index: 2;
          &:before {
            content: '';
            position: absolute;
            bottom: 100%;
            left: 50%;
            transform: translate(-50%, 5px) rotate(45deg);
            width: 10px;
            height: 10px;
            border: 1px solid rgba(0, 0, 0, 0.16);
            background-color: #fff;
            border-right-width: 0;
            border-bottom-width: 0;
            background-clip: padding-box;
          }
          &::v-deep span.title {
            font-weight: 600;
            span {
              color: #7C38E0;
            }
          }
          > div {
            font-size: 13px;
            font-weight: 500;
            line-height: 19px;
          }
        }
        &.on {
          color: #fff;
          background-color: #7C38E0;
          box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.35) inset;
          &:hover {
            background-color: #7C38E0;
          }
          .best-journey-tooltip {
            display: inline-block;
            width: 226px;
            opacity: 1;
          }
        }
        &:hover, &.on {
          .best-journey-tooltip {
            display: inline-block;
          }
        }
      }

    .ai-categorize-btn {
      color: #0074FF;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px;
      margin-top: 6px;
      text-decoration: none;
      font-size: 12px;
      font-weight: 500;

      .icon--tooltip-link {
        transform: rotate(90deg);
      }
      &:hover {
        text-decoration: underline;
      }
    }

  &.all {
    width: 195px !important;
    height: 122px !important;
    margin-left: 20px;
    border-radius: 61px;

    &.device--tablet {
      margin-left: -50px;
    }

    &.device--phone {
      margin-left: -80px;
    }

    &.device--all {
      margin-left: 0;
    }

    .item-info {
      position: absolute;
      left: 50%;
      top: calc(50% + 6px);
      bottom: auto;
      width: auto;
      height: auto;
      border-radius: 0;
      background: none;
      box-shadow: none;
      overflow: hidden;

      .left-side {
        width: auto;
      }

      .session {
        width: 100%;
        padding: 0;

        .count {
          display: inline-block;
          vertical-align: top;
          font-size: 12px;

          .number {
            margin: 4px 0 4px 0;
            font-size: 15px;
            display: block;
            font-weight: 500;
            line-height: 15px;

            &.small {
              font-size: 13px;
            }
          }
        }
      }
    }

    .hover-area {
      width: 100% !important;
    }

    .tracking-label {
      top: 50%;
      left: -13px;
      transform: translateY(-50%);
    }
    /deep/ .tracking-funnel {
      position: absolute;
      top: 50%;
      left: 0px;
      transform: translate(-100%, -50%);
    }

    .thumbnail--wrap {
      width: 100% !important;
      border-radius: 61px;
      background: none;
      box-shadow: none;
      padding: 0;

      &::after {
        content: none;
      }

      &:hover {
        box-shadow: none !important;
      }
    }

    .thumbnail {
      position: relative;
      top: 0;
      left: 0;

      &::before,
      &::after {
        content: none;
      }

      border-radius: 61px;
      background-color: #fff;
      box-shadow: 0 5px 7px -3px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.05);
      filter: none !important;

      .match-type {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 4.5px 8px;
        border-radius: 25px;
        background-color: #2C7899;
        color: #fff;
        font-size: 13px;
        font-weight: 500;
        text-transform: capitalize;
        &.exact {
          background: #005BAD;
        }
      }

      .thumbnail-all {
        position: absolute;
        left: 50%;
        right: auto;
        top: auto;
        bottom: 50%;
        font-size: 12px;
        color: #0e90a5;
        text-align: center;
        transform: translateX(-50%);

        h4 {
          font-size: 22px;
          font-weight: 500;
          white-space: nowrap;
          padding: 0 19px 5px;
          border-bottom: 1px solid #ebebeb;
          display: inline-block;
        }

        .percent {
          font-size: 12px;
          padding-left: 0.2em;
        }
      }
    }
    &.trackable {
      .thumbnail {
        .thumbnail-all {
          bottom: 40%;

          .tracking {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-bottom: 8px;
            border-bottom: 1px solid #CCC;
            h4 {
              padding-bottom: 6px;
              border: none;
              background: linear-gradient(90deg, $brandColor, $brandColor, $brandColor, $brandColor, $brandColor, #FFAEBD, $brandColor, $brandColor, $brandColor, $brandColor, $brandColor);
              background-size: 200%;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              animation: gradient-text-animation 2s infinite;
              font-size: 18px;
            }
            &-user {
              display: flex;
              align-items: flex-end;
              gap: 8px;
              max-width: 113px;
              color: #444;

              .tracking-user-label {
                font-size: 12px;
                font-weight: 500;
              }
              .tracking-user-value {
                  @include textEllipsis;
                  font-size: 14px;
                  font-weight: 600;
              }
            }

            @keyframes gradient-text-animation {
              from {
                background-position: 120% 50%;
              }
              to {
                background-position: -40% 50%;
              }
            }
          }
        }
      }
      .item-info {
        top: calc(60% + 8px);
      }
    }
  }

  &:not(.all) {
    .item-info-wrap {
      &:hover {
        .left-side {
          transform: translateX(-50%);
        }
        .right-side {
          transform: translateX(-100%);
        }

        .node-report {
          transform: translateX(0%);
        }
      }
    }
  }

  &.y1 {
    .transition {
      &.position2 {
        left: -78px !important;
      }
    }
  }

  &.active {
    width: 226px;
    height: 145px;
    z-index: 9;

    .transition {
      font-size: 14px;
      left: -38px;
      bottom: 163px;

      &.position2 {
        left: -63px;
        bottom: 78px !important;
      }

      &.position3 {
        left: -56px !important;
        bottom: -38px !important;
      }
    }

    .favorite {
      top: -21px;
      left: -9px;
    }

    .link-wrap {
      left: 10px;
      right: 10px;
    }

    .thumbnail--wrap {
      border-radius: 13px;
      box-shadow: 0 41px 40px -10px rgba(0, 0, 0, 0.4), inset 0 0 0 3px #333333;
      padding: 6px;

      &.hovering {
        box-shadow: 0 41px 40px -10px rgba(0, 0, 0, 0.4), inset 0 0 0 3px #0074ff !important;
      }

      &:after {
        left: 3px;
        top: 3px;
      }

      .nail {
        @include positionYcenter;
        display: block;
        z-index: 0;
        right: -6px;
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-left: 8px solid #333333;
        transition: border-left-color 0.2s ease
      }

      .more-wrap {
        right: 0 !important;
      }

      &.no-hover {
        border-color: #333333 !important;

        .nail {
          border-left-color: #333333 !important;
        }
      }
    }

    .thumbnail {
      &::after {
        background-color: rgba(0, 0, 0, 0.05);
      }
    }

    .thumbnail-group {
      .group-name {
        font-size: 19px;
        line-height: 25px;

        &.upcoming {
          font-size: 19px;
          line-height: 25px;
        }
      }
    }

    .rollback {
      padding: 6px 6px 6px 8px;
      font-size: 14px;

      .icon--rollback-new {
        background-image: url(../../assets/img/journey/icon_rollback_new_bold.svg);
      }
    }

    .item-info {
      @include positionXcenter;
      bottom: -23px;
      width: 200px;
      height: 54px;

      .left-side {
        width: 143px;
      }

      .right-side {
        width: 56px;
      }

      .session {
        width: 103px;
        padding: 17px 0 17px 11px;

        .icon {
          transform: translateX(0);
        }

        .number {
          transform: translateY(0.5px);
          font-size: 18px;
          line-height: 20px;

          &.small {
            transform: translateY(-0.5px);
            font-size: 14px;
          }
        }
      }

      .refresh {
        font-size: 13px;
      }

      .time {
        font-size: 13px;
      }

      .dropoff {
        font-size: 13px;
        padding-top: 13px;
      }
    }
  }

  &.unregistered:not(.all) {
    .thumbnail--wrap {
      .thumbnail {
        transform: scale(1.175);
        filter: blur(15px);

        &::after {
          background: rgba(0, 0, 0, 0.15);
        }
      }

      .buttons {
        .wrap {
          padding-bottom: 44px;
        }
      }
    }
  }

  &.disabled {
    opacity: 0.22;

    .thumbnail--wrap {
      .buttons {
        opacity: 0;
      }
    }
  }

  &:hover {
    z-index: 10;

    &::after {
      border-left-color: #0074ff;
    }

    .transition {
      &.disabled {
        opacity: 0.2;
      }
    }
  }

  &.seeall:not(.all) {
    .transition {
      &.disabled {
        opacity: 0.2;
      }
    }

    .item-info {
      bottom: -35px;
      height: 70px;

      .session {
        padding: 8px;
      }

      .dropoff {
        padding-top: 37px;
      }
    }

    &.active {
      .item-info {
        bottom: -33px;
        height: 74px;
      }
    }
  }

  &.trackable {
    .more-y {
      bottom: -129px;
    }
    &.device--all {
      .more-y {
        bottom: -110px;
      }
    }
  }

  &.device--tablet {
    height: 160px;

    .thumbnail-group {
      width: calc(100% - 28px);
      padding: 53px 14px 23px;

      .group-name {
        font-size: 13px;
        line-height: 17px;
        padding-right: 0;

        &.upcoming {
          font-size: 13px;
          line-height: 17px;
        }
      }
    }

    .favorite {
      left: -27px;
    }

    .link-wrap {
      left: -7px;
      right: 20px;
    }

    .item-info {
      transform: translateX(-48.5%);
    }

    .transition {
      left: -80px !important;
      bottom: 183px;

      &.position2 {
        left: -123px !important;
        bottom: 85px !important;
      }

      &.position3 {
        left: -70px !important;
        bottom: -38px !important;
      }
    }

    .hover-area {
      width: 124px;
    }

    .thumbnail--wrap {
      width: 124px;
    }

    .more-x {
      right: 7px !important;
    }

    &.active {
      height: 195px;

      .thumbnail-group {
        .group-name {
          font-size: 19px;
          line-height: 25px;
          line-clamp: 3;
          -webkit-line-clamp: 3;

          &.upcoming {
            font-size: 19px;
            line-height: 25px;
          }
        }
      }

      .item-info {
        bottom: -20px;
        transform: translateX(-49.5%);
      }

      .transition {
        &.position1 {
          left: -63px !important;
        }

        &.position2 {
          bottom: 108px !important;
        }
      }

      .favorite {
        left: -17px;
      }

      .link-wrap {
        left: 3px;
        right: 10px;
      }

      .hover-area {
        width: 149px;
      }

      .thumbnail--wrap {
        width: 149px;
      }
    }

    &.all {
      .item-info {
        bottom: -20px;
        transform: translateX(-39%);
      }
    }
  }

  &.device--all {
    height: 160px;
    width: 160px;

    .thumbnail-group {
      width: calc(100% - 56px);
      padding: 42px 28px 78px;
      height: calc(100% - 120px);

      .group-name {
        font-size: 16px;
        line-height: 120%;
        line-clamp: 2;
        -webkit-line-clamp: 2;

        &.upcoming {
          font-size: 16px;
          line-height: 120%;
        }
      }
    }

    .link-wrap {
      left: -7px;
      right: -7px;
    }

    .item-info {
      bottom: -4px;
    }

    .transition {
      left: -80px !important;
      bottom: 183px;

      &.position2 {
        left: -110px !important;
        bottom: 85px !important;
      }

      &.position3 {
        left: -80px !important;
        bottom: -20px !important;
      }
    }

    .rollback {
      top: 31px;
      right: -31px;
    }

    .hover-area {
      width: 160px;
    }

    .thumbnail--wrap {
      width: 160px;
      border-radius: 100%;

      .thumbnail-area {
        & /deep/ .icon-wrap-container {
          top: 40%;
          left: -19px;
        }
      }

      &:after {
        left: 12px;
        top: 1px;
        width: 55px;
        height: 42px;
        background-image: url('../../assets/img/targeting/icon--bookmark-round.svg');
      }

      .thumbnail-overflow {
        border-radius: 100%
      }

      .buttons {
        top: 30px;
        left: 20px;
      }

      &.hovering {
        .more-wrap {
          right: -28px;
        }
      }
    }

    .more-x {
      bottom: -95px;
    }

    .more-y {
      bottom: -70px;
    }

    &.active {
      width: 186px;
      height: 186px;

      .thumbnail-group {
        width: calc(100% - 56px);
        padding: 46px 28px 89px;
        height: calc(100% - 135px);

        .group-name {
          font-size: 18px;
          line-height: 120%;
          line-clamp: 2;
          -webkit-line-clamp: 2;

          &.upcoming {
            font-size: 18px;
            line-height: 120%;
          }
        }
      }

      .link-wrap {
        left: -5px;
        right: -5px;
      }

      .rollback {
        top: 40px;
        right: -29px;
      }

      .item-info {
        bottom: -2px;
      }

      .transition {
        &.position1 {
          left: -70px !important;
        }

        &.position2 {
          bottom: 100px !important;
        }
      }

      .hover-area {
        width: 186px;
      }

      .thumbnail--wrap {
        width: 186px;
        .thumbnail-area {
          & /deep/ .icon-wrap-container {
            left: -21px;
          }
        }
        &:after {
          left: 16px;
          top: 1px;
          width: 58px;
          height: 44px;
        }
        .buttons {
          top: 42px;
          left: 25px;
        }
      }
    }

    &.seeall:not(.all) {
      .item-info {
        bottom: -14px;
      }

      &.active {
        .item-info {
          bottom: -12px;
        }
      }
    }
  }

  &.device--phone {
    height: 150px;

    .thumbnail-group {
      width: calc(100% - 28px);
      padding: 48px 14px 28px;

      .group-name {
        font-size: 12px;
        line-height: 16px;
        padding-right: 0;
        line-clamp: 3;
        -webkit-line-clamp: 3;

        &.long {
          font-size: 14px;
        }

        &.upcoming {
          font-size: 12px;
          line-height: 16px;

          .icon {
            margin-top: 3px;
          }
        }
      }
    }

    .favorite {
      left: -36px;
    }

    .link-wrap {
      left: -17px;
      right: 28px;
    }

    .item-info {
      bottom: -27px;
    }

    .transition {
      left: -90px !important;
      bottom: 183px;

      &.position2 {
        left: -138px !important;
        bottom: 85px !important;
      }

      &.position3 {
        left: -80px !important;
        bottom: -35px !important;
      }
    }

    .hover-area {
      width: 94px;
    }

    .thumbnail--wrap {
      width: 94px;
    }

    .more-x {
      right: 43px !important;
    }

    &.hovered {
      .more-x {
        right: 17px !important;
      }
    }

    &.active {
      height: 190px;

      .thumbnail-group {
        .group-name {
          font-size: 16px;
          line-height: 21px;
          line-clamp: 3;
          -webkit-line-clamp: 3;

          &.upcoming {
            font-size: 16px;
            line-height: 21px;
          }
        }
      }

      .favorite {
        left: -33px;
      }

      .link-wrap {
        left: -13px;
        right: 25px;
      }

      .item-info {
        bottom: -27px;
      }

      .transition {
        &.position1 {
          left: -70px !important;
        }

        &.position2 {
          bottom: 105px !important;
        }
      }

      .hover-area {
        width: 120px;
      }

      .thumbnail--wrap {
        width: 120px;
      }
    }
  }
}

.children {
  position: relative;
  z-index: 2;
}

.slide-fade-enter-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
  transition-delay: 0.5s;
  z-index: 1;
}
.slide-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
  z-index: 1;
}

.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-enter-active {
  transition: opacity 0.5s ease;
  z-index: 1;
}
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.icon-wrap {
  position: relative;
  width: 16px;
  height: 16px;
  display: inline-block;
  vertical-align: middle;
  &.icon-with-warning {
    .icon {
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 20px;

      &.icon--ba-warning {
        display: none;
      }
    }
  }
}
</style>
